import(/* webpackMode: "eager" */ "/codebuild/output/src2276691906/src/doctor-dashboard/app/[locale]/(commonAuthenticatedLayout)/page.tsx");
